
import { createSlice } from "@reduxjs/toolkit"

const sidebarReturn = createSlice({
    name : 'rightSidebarReturn',
    initialState : {
        sidebarReturnData : [],
        successRatioData : [],
        tradeDuration : []
    },
    reducers : {
        setRightSidebarReturn : (state:any, action:any) => {
            state.sidebarReturnData = action.payload
        },
        setSuccessRatioData : (state:any, action:any) => {
            state.successRatioData = action.payload
        },
        setTradeDurationLS: (state:any, action:any) => {
            state.tradeDuration = action.payload
        }
    }
})


export const { setRightSidebarReturn, setSuccessRatioData, setTradeDurationLS }:any = sidebarReturn.actions;
export default sidebarReturn.reducer;